import 'dayjs/locale/th';
import Dayjs from 'dayjs';
import buddhistEra from 'dayjs/plugin/buddhistEra';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { AdapterFormats, FieldFormatTokenMap } from '@mui/x-date-pickers';

Dayjs.extend(buddhistEra);
Dayjs.locale('th');

// Reference: https://github.com/mui/mui-x/issues/9784#issuecomment-1651099013
const formatTokenMap: FieldFormatTokenMap = {
  // Year
  BB: 'year',
  BBBB: { sectionType: 'year', contentType: 'digit', maxLength: 4 },

  // Month
  M: { sectionType: 'month', contentType: 'digit', maxLength: 2 },
  MM: 'month',
  MMM: { sectionType: 'month', contentType: 'letter' },
  MMMM: { sectionType: 'month', contentType: 'letter' },

  // Day of the month
  D: { sectionType: 'day', contentType: 'digit', maxLength: 2 },
  DD: 'day',
  Do: { sectionType: 'day', contentType: 'digit-with-letter' },

  // Day of the week
  d: { sectionType: 'weekDay', contentType: 'digit', maxLength: 2 },
  dd: { sectionType: 'weekDay', contentType: 'letter' },
  ddd: { sectionType: 'weekDay', contentType: 'letter' },
  dddd: { sectionType: 'weekDay', contentType: 'letter' },

  // Meridiem
  A: 'meridiem',
  a: 'meridiem',

  // Hours
  H: { sectionType: 'hours', contentType: 'digit', maxLength: 2 },
  HH: 'hours',
  h: { sectionType: 'hours', contentType: 'digit', maxLength: 2 },
  hh: 'hours',

  // Minutes
  m: { sectionType: 'minutes', contentType: 'digit', maxLength: 2 },
  mm: 'minutes',

  // Seconds
  s: { sectionType: 'seconds', contentType: 'digit', maxLength: 2 },
  ss: 'seconds',
};

export default class DateAdapter extends AdapterDayjs {
  constructor({
    locale,
    formats,
  }: {
    locale?: string;
    formats?: Partial<AdapterFormats>;
    instance?: typeof Dayjs;
  }) {
    super({ locale, formats });
  }

  formatTokenMap = formatTokenMap;

  formatByString = (
    date: string | number | Dayjs.Dayjs | Date | null,
    format: string
  ) => {
    if (format === 'YYYY') {
      format = 'BBBB';
    }
    return this.dayjs(date).format(format);
  };
}
